import { useState } from "react";

const Textarea = ({ label, value, onChange, rows = 4, isDark = false, ...props }) => {
    const [focused, setFocused] = useState(false);
    const isFilled = value && value.length > 0;
    const containerClass = `textarea-container${focused ? ' focused' : ''}${isFilled ? ' filled' : ''}${isDark ? ' dark' : ''}`;

    return (
        <div className={containerClass}>
            <label className="textarea-label">{label}</label>
            <textarea
                className="textarea-field"
                defaultValue={value}
                onChange={onChange}
                rows={rows}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                {...props}
            />
        </div>
    );
};

export default Textarea;